import React from 'react';
import { Navigate, useParams } from 'react-router';

/**
 * Leitet den früheren Pfad `/admin/filetypes/:id` auf die neue Verwaltung um und nimmt die Id mit.
 *
 * Eigene Komponente statt eines schlichten `<Navigate>`, weil das Ziel den Routenparameter
 * enthält — als reines Attribut ließe sich der nicht einsetzen.
 */
export const LegacyFileTypeRedirect: React.FC = () => {
    const { id } = useParams();
    return <Navigate to={`/admin/settings/filetypes/${id ?? ''}`} replace />;
};

export default LegacyFileTypeRedirect;
